<template>
    <div>
        
        <ImplantsRejectionPosibility />
    </div>
</template>

<script>

import ImplantsRejectionPosibility from '../blog-details/ImplantsRejectionPosibility.vue'

export default {
    components: {
        
        ImplantsRejectionPosibility,
    }
}
</script>